import { render, staticRenderFns } from "./platTablelist.vue?vue&type=template&id=3b68d6e0"
import script from "./platTablelist.vue?vue&type=script&lang=js"
export * from "./platTablelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports